const gluelist = (array, glue = ', ', lastglue = '&') => {
	if (!array) {
		return '-';
	}

	if (array.length === 1) {
		return array[0];
	}

	const last = array.slice(-1)[0];
	const first = array.slice(0, -1).join(glue);

	return `${first} ${lastglue} ${last}`;
};

export { gluelist };
